import { AppBar } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledAppBar = styled(AppBar)(({ theme, addHeight }) => ({
  paddingRight: '0 !important',
  background: theme.palette.secondary.dark,
  backdropFilter: `blur(${theme.spacing(1)})`,
  boxShadow: 'none',
  transition: 'all 0.1s ease',
  borderBottom: `1px solid ${theme.palette.divider[4]}`,
  '& .NVContainerWrapperBackgroundDefault': {
    background: theme.palette.background.default,
  },
  '& .NVContainer': {
    [theme.breakpoints.down('xl')]: {
      paddingRight: theme.spacing(2),
      paddingLeft: theme.spacing(2),
    },
  },
  '&.NBStaticPosition': {
    position: 'absolute',
    top: 0,
  },
  '&.NBTransparent': {
    background:
      'linear-gradient(0deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.25) 100%)',
    backdropFilter: 'unset',
  },
  '&.NBAdVisible': {
    [theme.breakpoints.down('lg')]: {
      top: addHeight, // add mobile adv. height
    },
  },
  '&.NBScrolled': {
    background: theme.palette.secondary.dark,
    backdropFilter: `blur(${theme.spacing(1)})`,
    [theme.breakpoints.down('lg')]: {
      top: 0,
    },
  },

  '& .NavBarLogoContainer': {
    flexGrow: 1,
  },
  '& .NBLogoLink': {
    display: 'block',
    width: 'fit-content',
  },
  '& .NavBarLogo': {
    width: theme.typography.pxToRem(187),
    height: theme.typography.pxToRem(40),
  },
  '& .NavBarLogoWithFilter': {
    width: theme.typography.pxToRem(41),
    height: theme.typography.pxToRem(40),
  },
  '& .NMToolBar': {
    minHeight: 'unset',
    padding: theme.spacing(1.5, 0),
  },
  '& .NBNavigaationLinksContainer': {
    [theme.breakpoints.up('lg')]: {
      display: 'flex',
      marginRight: theme.spacing(3),
    },
    '&.showLargeDESKTOP': {
      [theme.breakpoints.down('xl')]: {
        display: 'none',
      },
    },
  },
  '&.NBShowFilters': {
    [theme.breakpoints.up('lg')]: {
      '& .NavBarLogoContainer': {
        flexGrow: 'unset',
      },
    },
    [theme.breakpoints.between('lg', 'xl')]: {
      '& .NavBarLogoContainer': {
        marginRight: 'auto',
      },
    },
  },
  '& .NavBarFiltersGeo': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.up('lg')]: {
      paddingBottom: theme.spacing(2),
      paddingTop: theme.spacing(2),
    },
    [theme.breakpoints.between('lg', 'xl')]: {
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
  },
}));

export default StyledAppBar;
